var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.current.version,{tag:"div",class:_vm.myclass,style:(_vm.current.style),attrs:{"dataAll":{current:_vm.current}}})}
var staticRenderFns = []

export { render, staticRenderFns }